import { render, staticRenderFns } from "./GoodIcon.vue?vue&type=template&id=479c2e58&"
import script from "./GoodIcon.vue?vue&type=script&lang=js&"
export * from "./GoodIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports